import Background from 'app/pages/frames/components/styled-components/Background';
import React from 'react';

interface Props {
  children: React.ReactNode;
}
export const PaymentMethodContent = ({ children }: Props): JSX.Element => (
  <Background className="PaymentMethodContent">{children}</Background>
);
